import { api } from '../finance/api/client';

export const getMyMeetings = async (filter = 'all', page = 0, size = 10) => {
    const res = await api.get(`/sales/meetings/my-meetings?filter=${filter}&page=${page}&size=${size}`);
    return res.data;
};

export const getMeetingById = async (id) => {
    const res = await api.get(`/sales/meetings/${id}`);
    return res.data;
};

export const getMeetingsByRange = async (start, end) => {
    const res = await api.get(`/sales/meetings/range?start=${start}&end=${end}`);
    return res.data;
};

export const createMeeting = async (data) => {
    const res = await api.post('/sales/meetings', data);
    return res.data;
};

export const updateMeeting = async (id, data) => {
    const res = await api.put(`/sales/meetings/${id}`, data);
    return res.data;
};

export const deleteMeeting = async (id) => {
    const res = await api.delete(`/sales/meetings/${id}`);
    return res.data;
};

export const updateMeetingStatus = async (id, status) => {
    const res = await api.patch(`/sales/meetings/${id}/status?status=${status}`);
    return res.data;
};
